/**
 * UUID-generator voor id's die als database-sleutel dienen.
 *
 * `genId('assignment')` maakt een leesbare sleutel (`assignment_l4k2j_x9f3qa`)
 * en dat volstond zolang alles in localStorage stond. Zodra zo'n id in een
 * `uuid`-kolom moet landen, faalt de insert — met een typefout die niets zegt
 * over de oorzaak.
 *
 * Gebruik dit voor alles dat naar Supabase geschreven wordt; `genId` blijft
 * prima voor puur lokale sleutels.
 *
 * `crypto.randomUUID()` bestaat alleen in een secure context (https of
 * localhost). De fallback gebruikt `getRandomValues` — dezelfde bron van
 * toeval, alleen met de opmaak met de hand. Bewust géén `Math.random()`:
 * botsende id's zouden hier twee opdrachten laten samenvallen.
 */
export function genUuid(): string {
  const c = globalThis.crypto;
  if (c && typeof c.randomUUID === 'function') return c.randomUUID();
  const bytes = new Uint8Array(16);
  if (c && typeof c.getRandomValues === 'function') {
    c.getRandomValues(bytes);
  } else {
    throw new Error('genUuid: geen veilige bron van toeval beschikbaar (crypto ontbreekt).');
  }
  // Versie 4, variant 10xx — anders is het geen geldige uuid voor Postgres.
  bytes[6] = bytes[6] & 0x0f | 0x40;
  bytes[8] = bytes[8] & 0x3f | 0x80;
  const hex = Array.from(bytes, b => b.toString(16).padStart(2, '0'));
  return [hex.slice(0, 4).join(''), hex.slice(4, 6).join(''), hex.slice(6, 8).join(''), hex.slice(8, 10).join(''), hex.slice(10, 16).join('')].join('-');
}